import { render, staticRenderFns } from "./PostBody.vue?vue&type=template&id=1b4ae256&scoped=true&"
import script from "./PostBody.vue?vue&type=script&lang=js&"
export * from "./PostBody.vue?vue&type=script&lang=js&"
import style0 from "./PostBody.vue?vue&type=style&index=0&id=1b4ae256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ae256",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VSnackbar,VTab,VTabItem,VTabs})
